import imageCompression from 'browser-image-compression';

export const UPLOAD_TIMEOUT_MS = 90000;

const MAX_UPLOAD_MB = 1.2;

/**
 * Compress a camera/gallery photo before upload (mobile networks choke on 5-15MB
 * originals). Preserves EXIF (GPS + DateTimeOriginal) required by backend
 * anti-tampering validation, dropping only the orientation flag (pixels are
 * already rotated by the compressor). Falls back to the original file on any error.
 */
export async function compressPhoto(file) {
  try {
    if (!file || !/^image\//i.test(file.type || '')) return file;
    if (file.size <= MAX_UPLOAD_MB * 1024 * 1024) return file;
    const name = (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg';
    // Vía de BAJA memoria primero: createImageBitmap con resize decodifica ya
    // re-escalado (una foto de 48MP decodificada completa ≈ 200MB de bitmap y
    // mataba la pestaña en teléfonos de poca RAM — caso HONOR X5C Plus).
    let blob = null;
    try {
      const bmp = await createImageBitmap(file, {
        resizeWidth: 1800, resizeQuality: 'medium', imageOrientation: 'from-image',
      });
      const canvas = document.createElement('canvas');
      canvas.width = bmp.width; canvas.height = bmp.height;
      canvas.getContext('2d').drawImage(bmp, 0, 0);
      bmp.close();
      blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.85));
      canvas.width = canvas.height = 0;
    } catch { blob = null; }
    if (!blob) {
      blob = await imageCompression(file, {
        maxSizeMB: MAX_UPLOAD_MB,
        maxWidthOrHeight: 1800,
        useWebWorker: true,
        initialQuality: 0.85,
        fileType: 'image/jpeg',
      });
    }
    try {
      const withExif = await imageCompression.copyExifWithoutOrientation(file, blob);
      return new File([withExif], name, { type: 'image/jpeg' });
    } catch {
      return new File([blob], name, { type: 'image/jpeg' });
    }
  } catch {
    return file;
  }
}
